import { useNavigate } from "react-router-dom";

import { Chip } from "@mui/material";

interface ProChipProps {
  nomargin?: boolean;
  hasRightMargin?: boolean;
}
const ProChip: React.FC<ProChipProps & { height?: string, width?: string, openPage?:boolean }> = ({
  nomargin = false,
  hasRightMargin = false,
  openPage = true,
  height,
  width,
}) => {
  const navigate = useNavigate();
  return (
    <Chip
      label="Pro"
      color="primary"
      size="small"
      onClick={openPage ? () => navigate("/pro") : null}
      className="ml-[5px]"
      sx={{
        fontWeight: "700",
        borderRadius: 2,
        paddingY: 0,
        marginLeft: nomargin ? "0px" : "5px",
        marginRight: hasRightMargin ? "5px" : "0px",
        height: height || undefined,
        width: width || undefined,
        fontSize: "12px",
      }}
    />
  );
};

export default ProChip;
